import React from 'react';
import { Card, CardContent } from '@/shared/ui/card';
import { Label } from '@/shared/ui/label';
import { Camera, Upload, Keyboard, Files } from 'lucide-react';
import { CAPTURE_METHOD_LABELS } from '../constants';
import type { CaptureMethod } from '../types';

const METHODS: { id: CaptureMethod; icon: React.ReactNode; description: string }[] = [
  { id: 'snap_card', icon: <Camera className="h-8 w-8" />, description: 'Camera capture' },
  { id: 'upload_image', icon: <Upload className="h-8 w-8" />, description: 'Photo or screenshot' },
  { id: 'manual_entry', icon: <Keyboard className="h-8 w-8" />, description: 'Type it in' },
  { id: 'bulk_upload', icon: <Files className="h-8 w-8" />, description: 'Select multiple cards' },
];

interface CaptureMethodStepProps {
  value: CaptureMethod | null;
  onChange: (method: CaptureMethod) => void;
}

export function CaptureMethodStep({ value, onChange }: CaptureMethodStepProps) {
  return (
    <div className="space-y-4">
      <Label className="text-base font-medium">How do you want to capture?</Label>
      <div className="grid gap-3 sm:grid-cols-2">
        {METHODS.map(({ id, icon, description }) => (
          <Card
            key={id}
            className={`cursor-pointer transition-colors hover:border-primary ${
              value === id ? 'border-primary bg-primary/5' : ''
            }`}
            onClick={() => onChange(id)}
          >
            <CardContent className="flex items-center gap-4 p-4">
              <div className="text-primary">{icon}</div>
              <div>
                <div className="font-medium">{CAPTURE_METHOD_LABELS[id] ?? id}</div>
                <div className="text-sm text-muted-foreground">{description}</div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
